import { linksWithQuery } from '[theme-lib]/links';

export function BookSlotPromptFlashMessage(showBookASlotPrompt) {
  return showBookASlotPrompt(
    `<a href="${linksWithQuery.BOOK_DELIVERY({ fromBookSlotPrompt: true })}"` +
    ' onclick="handleBookSlotPromptConfirmClick(event)">Book a delivery</a> to see up-to-date stock information.'
  );
}

export function BookSlotPromptModal() {
  return null;
}
